import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ethics1, ethics2, ethics3, ethics4, ethics5, rightArrow, rightArrowHover, whyUs } from '../../../assets/images';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion, AnimatePresence } from 'framer-motion';


const Ethics = () => {



      const { t } = useTranslation();

       useEffect(() => {
                          AOS.init({ duration: 2000, once: false }); 
                        }, []);

      const services = [
        {
          id: 1,
          title: 'Düzgünlük',
          description: "Şirkət səhmdarlarına və işçilərinə qarşı düzgünlük siyasəti bizim ən əsas dəyərlərimizdir. “Düzgünlük ən yaxşı siyasətdir” anlayışı əsas hədəfimizdir.",
          img: ethics1
        },
        {
          id: 2,
          title: 'Məxfilik',
          description: "Şirkətimizin 3-cü şirkətlərə və şəxslərə qarşı şirkətə aid olan məlumatların məxfilik qaydalarına riayət edilərək qorunmasını təmin etməliyik.",
          img: ethics2
        },
        {
          id: 3,
          title: 'Mənfəət',
          description: "Şirkət öz işçilərin şirkətdən sui istifadə edərək özlərinə etik olmayan yollardan gəlir əldə etmələrini qətiyyən qadağan edir.",
          img: ethics3
        },
        {
          id: 4,
          title: 'Müştəri',
          description: "Şirkətimizin ən əsas hədəfi olmaqla yanaşı müştərilərin məmnuniyyəti, onların ehtiyyaçlarını hər daim qarşılamağı və onların tələblərinin hər zaman bir önündə olmağı özünə vəzifə sayır.",
          img: ethics4
        },
        {
          id: 5,
          title: 'Səhmdarlara qarşı məsuliyyətimiz',
          description: "Şirkətin davamlılığına və keyfiyyətli işlər görməyinə prioritet tanıyaraq lazımsız risklərdən uzaq durmağı və şirkətimizin davamlı gəlir əldə etməsini özümüzə əsas vəzifə sayırıq.",
          img: ethics5
        }
      ];

      const [selectedService, setSelectedService] = useState(services[0]);
            const [dropdownOpen, setDropdownOpen] = useState(false);

  return ( 
    <div data-aos="fade-up" className='mt-[88px] md:mt-[104px]'>
        <div className='max-w-containerSm md:max-w-container mx-auto'>
        <div>
        <p className='text-[24px] md:text-[32px] font-medium text-[#01A396] pt-[45px]'>{t("Şirkətin etik kodeksləri")}</p>
        </div>
        <div className='md:flex justify-between items-center mt-[32px] pb-[44px]'>
      {/* Sol Kategori Listesi */}
      <div className='md:w-[30%] hidden md:flex flex-col gap-3'>
        {services.map((card, index) => (
         <div
         key={index}
         onClick={() => setSelectedService(card)}
         className={`w-full cursor-pointer px-4 py-3 rounded-lg font-medium hover:bg-[#01A396] hover:text-white bg-white transition-all duration-300 hover:pl-10 ${
           selectedService.title === card.title
             ? 'bg-[#01A396] text-white'
             : 'text-[#1C1C1C] bg-[white] border border-[#E5E5E5]'
         }`}
       >
         {card.title}
       </div>
       
        ))}
      </div>
      <div className="md:hidden z-30 relative w-full">
  <button
    onClick={() => setDropdownOpen(!dropdownOpen)}
    className="w-full px-4 py-3 rounded-lg border border-gray-300 text-[#1C1C1C] bg-white flex justify-between items-center"
  >
    {selectedService.title}
    <svg
      className={`w-4 h-4 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  {dropdownOpen && (
  <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-lg mt-2 z-40 px-2 py-2">
    <div className="flex flex-col space-y-2">
      {services.map((service, index) => (
        <div
          key={index}
          onClick={() => {
            setSelectedService(service);
            setDropdownOpen(false);
          }}
          className={`px-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md ${
            selectedService.title === service.title ? 'bg-[#01A396] text-white font-medium' : ''
          }`}
        >
          {service.title}
        </div>
      ))}
    </div>
  </div>
)}


</div>

  <AnimatePresence mode="wait">
  <div className='relative md:flex flex-col md:flex-row items-center mt-8 md:mt-0 md:w-[60%]' key={selectedService.id}>
    {/* Görsel */}
    <motion.div
      key={selectedService.id + '-img'}
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.4 }}
      className='md:w-[55%] ml-auto z-0'
    >
      <img className='w-full h-full object-cover' src={selectedService?.img} />
    </motion.div>

    {/* Metin Kutusu */}
    <motion.div
      key={selectedService.id + '-text'}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.4 }}
      className='relative z-10 w-full md:w-[55%] h-auto md:min-h-[216px] bg-white py-5 px-6 border border-[#E5E5E5] rounded-[12px] 
        -mt-10 md:mt-0 md:absolute md:left-0'
    >
      <p className='text-[#1C1C1C] font-medium text-[18px] md:text-[24px]'>{selectedService?.title}</p>
      <p className='mt-6 text-[#1C1C1C]'>{selectedService?.description}</p>

      <a className='group' href={`/about`}>
        <div className='flex items-center mt-6 justify-between w-[100px] mx-auto md:mx-0 rounded-[12px] bg-white text-[#1C1C1C] h-[46px]'>
          <p className='transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
          <img
            className='w-2 transition-opacity duration-300 group-hover:hidden'
            src={rightArrow}
            alt=""
          />
          <img
            className='w-2 transition-opacity duration-300 hidden group-hover:block'
            src={rightArrowHover}
            alt=""
          />
        </div>
      </a>
    </motion.div>
  </div>
</AnimatePresence>
    </div>


    </div>
    </div>
  )
}

export default Ethics